import qs from 'qs';
import { fetchGET, fetchPOST } from 'api/fetchHelper';

const PATH = '/_api/v1/chat_messages';

const ChatMessages = {
  getAll: ({ page, filter, include, fields, signal } = {}) => (
    fetchGET(`${PATH}?${qs.stringify({ page, filter, include, fields }, { encodeValuesOnly: true })}`, signal)
  ),
  create: ({ chatRoomId, include, text } = {}) => {
    if (!chatRoomId) throw new Error('chatRoomId is not defined');

    const body = {
      data: { type: 'chat_message', attributes: { text } },
    };

    const queryString = qs.stringify({ chat_room_id: chatRoomId, include }, { encodeValuesOnly: true });

    return fetchPOST(`${PATH}?${queryString}`, body);
  },
};

export default ChatMessages;
